import {
    ArrowDown,
    ArrowLeft,
    ArrowLeftBold,
    ArrowRight,
    ArrowRightBold,
    ArrowUp,
    Calendar,
    CaretBottom,
    CaretLeft,
    CaretRight,
    Check,
    CircleCheckFilled,
    CircleClose,
    CircleCloseFilled,
    CirclePlus,
    Clock,
    Close,
    CloseBold,
    Collection,
    CopyDocument,
    DArrowRight,
    Delete,
    DeleteFilled,
    Document,
    DocumentAdd,
    DocumentDelete,
    DocumentRemove,
    Download,
    Edit,
    EditPen,
    Expand,
    Files,
    Finished,
    Fold,
    Folder,
    FolderAdd,
    FolderOpened,
    FullScreen,
    Guide,
    Hide,
    Link,
    Loading,
    Location,
    Management,
    Memo,
    Menu,
    Message,
    MoreFilled,
    Odometer,
    Operation,
    Plus,
    Position,
    Promotion,
    QuestionFilled,
    Rank,
    Reading,
    Refresh,
    RefreshLeft,
    RefreshRight,
    Remove,
    RemoveFilled,
    Right,
    Search,
    Select,
    Setting,
    Share,
    Stamp,
    Star,
    StarFilled,
    SuccessFilled,
    Tickets,
    Timer,
    Upload,
    UploadFilled,
    User,
    UserFilled,
    View,
    Warning,
    WarningFilled
} from "@element-plus/icons-vue";

const elementPlusIcons = {
    ArrowDown,
    ArrowLeft,
    ArrowLeftBold,
    ArrowRight,
    ArrowRightBold,
    ArrowUp,
    Calendar,
    CaretBottom,
    CaretLeft,
    CaretRight,
    Check,
    CircleCheckFilled,
    CircleClose,
    CircleCloseFilled,
    CirclePlus,
    Clock,
    Close,
    CloseBold,
    Collection,
    CopyDocument,
    DArrowRight,
    Delete,
    DeleteFilled,
    Document,
    DocumentAdd,
    DocumentDelete,
    DocumentRemove,
    Download,
    Edit,
    EditPen,
    Expand,
    Files,
    Finished,
    Fold,
    Folder,
    FolderAdd,
    FolderOpened,
    FullScreen,
    Guide,
    Hide,
    Link,
    Loading,
    Location,
    Management,
    Memo,
    Menu,
    Message,
    MoreFilled,
    Odometer,
    Operation,
    Plus,
    Position,
    Promotion,
    QuestionFilled,
    Rank,
    Reading,
    Refresh,
    RefreshLeft,
    RefreshRight,
    Remove,
    RemoveFilled,
    Right,
    Search,
    Select,
    Setting,
    Share,
    Stamp,
    Star,
    StarFilled,
    SuccessFilled,
    Tickets,
    Timer,
    Upload,
    UploadFilled,
    User,
    UserFilled,
    View,
    Warning,
    WarningFilled
};

export function registerElementPlusIcons(app) {
    Object.entries(elementPlusIcons).forEach(([name, component]) => {
        app.component(name, component);
    });
}
